
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="false" >
            <a-form-item label="类型">
              <a-select
                      showSearch
                      optionFilterProp="title"
                      v-model="queryParam.clubleixing"
                      placeholder="类型"
                      allowClear
              >
                <a-select-option   title="考级中心" value="学校俱乐部">学校俱乐部</a-select-option>
                <a-select-option   title="社会俱乐部" value="社会俱乐部">社会俱乐部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报状态">
              <a-select v-model="queryParam.registstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">选择商品</a-select-option>
                <a-select-option value="2">等待管理员确认订单</a-select-option>
                <a-select-option value="3">确认金额</a-select-option>
                <a-select-option value="4">支付订单</a-select-option>
                <a-select-option value="5">支付成功</a-select-option>
                <a-select-option value="6">已发货</a-select-option>
                <a-select-option value="7">已安装</a-select-option>
                <a-select-option value="8">已完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="联系电话">
                <a-input v-model="queryParam.phone" placeholder="联系电话"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                        v-model="time_range_moment"
                        style="width: 100%"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced"  v-if="false"  style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <a-tag  color="green">
              {{record.grade}}{{record.gradetype}}
            </a-tag>

            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            收件人:{{record.name}} <span style="color: #999">手机:{{record.phone}}</span>


          </div>
      </span>
      <span slot="code" slot-scope="text,record">
            ¥{{record.order_price}}
            <br/>
        物料费:¥{{record.goods_price}} 运费:¥{{record.express_price}}  安装费:¥{{record.service_price}}
            <br/>
            申请时间 {{record.create_time|timeFormat}}

      </span>
      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.status==1"  >选择商品</a-tag>
        <a-tag v-else-if="record.status==2" color="red" >等待管理员确认订单</a-tag>
        <a-tag v-else-if="record.status==3"  >确认金额</a-tag>
        <a-tag v-else-if="record.status==4"  >支付订单</a-tag>
        <a-tag v-else-if="record.status==4"  >支付成功</a-tag>
        <a-tag v-else-if="record.status==5"  >已发货</a-tag>
        <a-tag v-else-if="record.status==6"  >已安装</a-tag>
        <a-tag v-else-if="record.status==7" color="green" >已完成</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="downloadHetong(record)">下载合同</a>

        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="收件人"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'name',
          {rules: []}
        ]"
                          placeholder="请输入收件人"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'phone',
          {rules: []}
        ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="省市区"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="详细地址"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'address',
          {rules: []}
        ]"
                          placeholder="请输入地址"/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      label="场地照片"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <pic-uploader
                        :file-list="formData.changdi_pic"
                />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="需要安装"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="need_service" :checkedValue="1" :unCheckedValue="2"  checkedChildren="需要" unCheckedChildren="不需要" />
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      label="特殊情况说明"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <a-textarea autosize v-decorator="[
          'diynote',
          {rules: []}
        ]"
                            placeholder="特殊情况说明"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
            </a-col>


          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="需要发票"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="need_fapiao" :checkedValue="1" :unCheckedValue="2"  checkedChildren="需要" unCheckedChildren="不需要" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
          <a-row :gutter="48" v-show="formData.need_fapiao == 1">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票抬头"
                      hasFeedback
              >

                <a-input  v-decorator="[
          'fapiao_taitou',
          {rules: [ ]}
        ]"
                          placeholder="请输入发票抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票税号"
                      hasFeedback
              >

                <a-input  v-decorator="[
          'fapiao_shuihao',
          {rules: [ ]}
        ]"
                          placeholder="请输入发票税号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="运费"
                      hasFeedback
              >

                <a-input  v-decorator="[
          'express_price',
          {rules: [ ]}
        ]"
                          placeholder="请输入运费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="安装费"
                      hasFeedback
              >

                <a-input  v-decorator="[
          'service_price',
          {rules: [ ]}
        ]"
                          placeholder="请输入安装费"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="物流信息"
                      hasFeedback
              >

                <a-textarea autosize  v-decorator="[
          'express_info',
          {rules: [ ]}
        ]"
                          placeholder="请输入物流信息"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>


          <a-divider>审核信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      label="验收图片证明"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <pic-uploader
                        :file-list="formData.yanshou_pic"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="验收表上传"
                      hasFeedback
              >
                <pic-uploader
                        :file-list="formData.yanshoubiao_pic"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="审核状态"
                      hasFeedback
              >
                <a-radio-group v-model="formData.status" buttonStyle="solid">
                  <a-radio-button :value="0">未提交</a-radio-button>
                  <a-radio-button :value="1">选择器材</a-radio-button>
                  <a-radio-button :value="2">完善收货信息</a-radio-button>
                  <a-radio-button :value="3">管理员确认金额</a-radio-button>
                  <a-radio-button :value="4">正在付款</a-radio-button>
                  <a-radio-button :value="5">支付成功</a-radio-button>
                  <a-radio-button :value="6">已发货</a-radio-button>
                  <a-radio-button :value="7">已安装</a-radio-button>
                  <a-radio-button :value="8">完成</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>合同信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      label="客户下载合同"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <file-uploader
                        :file-list="formData.hetong_down"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="客户上传合同"
                      hasFeedback
              >
                <file-uploader
                        :file-list="formData.hetong_upload"
                />
              </a-form-item>
            </a-col>
          </a-row>




        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getJiansheOrderList ,getJiansheDetail,editJianshe } from '@/api/club'
  export default {
    name: 'ExameCenterList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        formData:{
          id:0,
          danwei:'',
          changdi_pic:[],
          namekeys:[],
          areas:[],
          zhizhaopic:[],
          shenbaozip:[],
          yanshou_pic:[],
          yanshoubiao_pic:[],
          xflag:[],
          is_tequan:2,
        },
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '申报信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '价格信息',
            dataIndex: 'code',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(parameter,this.queryParam);
          return getJiansheOrderList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getJiansheDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editJianshe({
              id:self.formData.id,
              name:values.name,
              phone:values.phone,
              area:self.formData.areas[self.formData.areas.length-1],
              address:values.address,
              changdi_pic:self.formData.changdi_pic,
              need_service:self.formData.need_service,
              diynote:values.diynote,
              need_fapiao:self.formData.need_fapiao,
              fapiao_taitou:values.fapiao_taitou,
              fapiao_shuihao:values.fapiao_shuihao,
              express_price:values.express_price,
              service_price:values.service_price,
              express_info:values.express_info,
              yanshou_pic:self.formData.yanshou_pic,
              yanshoubiao_pic:self.formData.yanshoubiao_pic,
              hetong_down:self.formData.hetong_down,
              hetong_upload:self.formData.hetong_upload,
              status:self.formData.status,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
      downloadHetong(record){
        window.open(setting.apiBaseURL+'/adminapi/club/hetongdownload?id='+record.id);
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
      jinduFilter(value){
        switch (value){
          case 1:
            return `联系申报单位`;
          case 2:
            return `告知省级省市并征求意见+申报单位积极准备中`;
          case 3:
            return `申报单位积极准备中`;
          case 4:
            return `条件已具备，等待验收`;
          case 5:
            return `等待全国啦啦操省市验收`;
          case 6:
            return `验收并授牌`;
          case 7:
            return `同意考试`;
        }
      },
    },
    watch: {
    }
  }
</script>
